import React from "react";
import { useNavigate } from "react-router-dom";

export default function SuccessPayment() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <h2 className="text-2xl font-bold mb-4 text-green-600">Payment Successful!</h2>
      <p className="mb-6">Thank you for your purchase.</p>
      <button
        onClick={() => navigate("/")}
        className="bg-[#35C3D9] hover:bg-[#27AAC0] text-white font-semibold py-3 px-6 rounded-lg transition"
      >
        Go to Home
      </button>
    </div>
  );
}
